import styled from 'styled-components';

export default styled.div`
  border: none;
  border-radius: 4px;
  padding: 1em;
  font-size: 0.8em;
  cursor: pointer;
`;
